import { DashboardList } from '@modules/dashboard/components/DashboardList';
import { PushPinRounded } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import { useGetUser } from 'v2/core/services/user';

interface PinnedDashboardsListV2Props {
  onClose: () => void;
}

export const PinnedDashboardsListV2 = ({
  onClose,
}: PinnedDashboardsListV2Props) => {
  const { pinnedDashboards: dashboards = [] } = useGetUser();

  if (!dashboards?.length) {
    return null;
  }

  return (
    <Stack>
      <Stack direction="row" spacing={1} alignItems="center">
        <PushPinRounded sx={{ fontSize: '12px' }} />
        <Typography variant="caption">Pinned Dashboards</Typography>
      </Stack>
      <DashboardList
        dashboards={dashboards}
        onClose={onClose}
        testID="pinned-dashboards-list"
      />
    </Stack>
  );
};
